module.exports = __webpack_public_path__ + "officialStatic/img/businessMore.2409b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/businessMore.png
// module id = MJgo
// module chunks = 0